import React from "react";
import EntityManagement from "../../components/EntityManagement/EntityManagement";

const Users = () => (
  <EntityManagement
    title="All users"
    subtitle="Every account on the platform. One user can have seller and vendor access."
    showWallet
  />
);

export default Users;
